
import { Helmet, HelmetProvider } from 'react-helmet-async';
import HeroSection from "../../components/ClientComponents/tech/HeroSection";
import OurTechClients from "../../components/ClientComponents/tech/OurTechClients";
import FeaturedCaseStudy from "../../components/ClientComponents/tech/FeaturedCaseStudy"

const Tech = () => {
  return (
    <>
      <HelmetProvider>
      <Helmet>
        <title>CE & Tech | Brand Acumen</title>
        <meta name="description" content="See some of the amazing clients we've worked with at Brand Acumen." />
        <meta name="description" content="Welcome to the homepage of Brand Acumen." />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Home | Brand Acumen" />
        <meta property="og:description" content="Welcome to the homepage of Brand Acumen." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content="https://brandacumen.co/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Home | Brand Acumen" />
        <meta name="twitter:description" content="Welcome to the homepage of Brand Acumen." />
        <meta name="twitter:image" content="/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>

      <HeroSection />
      <OurTechClients />
      <FeaturedCaseStudy />
      </HelmetProvider>
    </>
  );
};

export default Tech;
